import {
  Environment,
  FetchFunction,
  IEnvironment,
  Network,
  RecordSource,
  Store,
} from 'relay-runtime';

const fetchGraphQL: FetchFunction = async (request, variables) => {
  const resp = await fetch('/gateway/api/graphql', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: request.text, variables }),
  });
  if (!resp.ok) {
    throw new GraphQLConnectionError('GraphQL error occurred');
  }
  return await resp.json();
};

export class GraphQLConnectionError extends Error {}

export const getEnvironment = () =>
  new Environment({
    store: new Store(new RecordSource({})),
    network: Network.create(fetchGraphQL),
  }) as IEnvironment;
